module.exports = __webpack_public_path__ + "fonts/Euclid Circular B Bold.cca7e373.woff";